import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isOauthMcpMarketplaceClient = objectOf({
  key: string,
  status: anyOf(nullOrUndefined, enumOf("approved", "blocked")),
  client_ids: arrayOf(string),
  redirect_uris: arrayOf(string),
  last_updated_by_id: anyOf(nullOrUndefined, string),
  last_updated_by_name: anyOf(nullOrUndefined, string),
  last_updated_at: anyOf(nullOrUndefined, string),
});

export const isGetCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsResult = objectOf({
  marketplace_clients: arrayOf(isOauthMcpMarketplaceClient),
});
